import { createSlice } from '@reduxjs/toolkit';

const initialState: {
  currentStep: number;
} = {
  currentStep: 0,
};

export const createListSlice = createSlice({
  name: 'createNewList',
  initialState,
  reducers: {
    resetCreateList: () => initialState,
    incrementCurrentStep: (state) => {
      state.currentStep += 1;
    },
    decrementCurrentStep: (state) => {
      state.currentStep -= 1;
    },
  },
});

export const {
  incrementCurrentStep,
  decrementCurrentStep,
  resetCreateList,
} = createListSlice.actions;

export default createListSlice.reducer;
